import apiEndpoints from '../constants/ApiEndpoints';
import authUtil from '../utils/auth_util';
import axios from "axios";


axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN'
axios.defaults.timeout = 8000
axios.defaults.timeoutErrorMessage = 'timeout'
axios.defaults.baseURL = process.env.NEXT_PUBLIC_SERVER_BASE_URL

// const headers = {
//     'Content-Type': 'application/json',
// }

const getHeader = (headers = {}) => {
    headers['Content-Type'] = 'application/json'
    headers['token'] = authUtil.getCredentials('auth-token')
    return headers
}

const getHeaderForFile = (headers = {}) => {
    headers['Content-Type'] = 'multipart/form-data'
    headers['token'] = authUtil.getCredentials('auth-token')
    return headers
}

const cleanPayload = (payload) => {
    // -> Remove "", 0, false, null, undefined values of keys from dictionary Object
    return Object.entries(payload).reduce((a,[k,v]) => (v ? (a[k]=v, a) : a), {})
} 

const paramDictToUrl = (payload) => {
    var str = [];
    for(var p in payload) {
        if (payload[p]) {
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(payload[p]));
        }
    }
    return str.join("&");
}


export default {

    // // -> Axios POST Request
    // requestPOST: (url, reqPayload, headers, successResponse, errorResponse) => {
    //     axios.post(url, reqPayload, {headers: headers})
    //     .then(response => {
    //         if (successResponse) {
    //             successResponse(response)
    //         }
    //     }).catch(error => {
    //         if (errorResponse) {
    //             errorResponse(error)
    //         }
    //     })
    // },

    // -> Axios GET Request
    requestGET: (url, reqPayload={}, attach_token=false) => {
        let headers = attach_token ? getHeader() : {};
        let url_param = '';
        if (reqPayload) {
            url_param = paramDictToUrl(reqPayload);
            url = url + '?' + url_param;
        }
        // var url_obj = new URL(url);
        // url_obj.search = new URLSearchParams(reqPayload); 
        return axios.get(`${apiEndpoints.apiHost}${url}`, {headers: headers})
    },
    
    // -> Axios POST Request
    requestPOST: (url, reqPayload, attach_token=false) => {
        let headers = attach_token ? getHeader() : {};
        reqPayload = cleanPayload(reqPayload)
        return axios.post(`${apiEndpoints.apiHost}${url}`, reqPayload, {headers: headers})
    },

    // -> Axios POST attached file Request
    requestFilePOST: (url, reqPayload, attach_token=false) => {
        let headers = attach_token ? getHeaderForFile() : {};
        return axios.post(`${apiEndpoints.apiHost}${url}`, reqPayload, {headers: headers})
    },

    // -> Axios PUT Request
    requestPUT: (url, reqPayload, attach_token=false) => {
        let headers = attach_token ? getHeader() : {};
        reqPayload = cleanPayload(reqPayload)
        return axios.put(`${apiEndpoints.apiHost}${url}`, reqPayload, {headers: headers})
    },

}